import * as React from 'react'
import s from './styles.module.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import LearnMoreButton from '../../../../ui/LearnMoreButton'
import OneWeekImplementation from '../OneWeekImplementation'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'

const OneWeekImplementationSection = () => (
  <section className='alumni-content'>
    <div className='box'>
      <Glow position='right' />

      <AnimatedContainer className={`recruiting-grid-container ${s.gridExt}`}>
        <div>
          <motion.p className='recruiting-main-title' variants={titleAnimation}>
            Fast Implementation
          </motion.p>
          <motion.p
            className='recruiting-sub-content-container'
            variants={subtitleAnimation}
          >
            <span>
              1. Securely send Pod your alumni directory and Pod will create a
              branded experience
            </span>
            <span>
              2. Pod will use the data in your directory to analyze and map your
              network
            </span>
            <span>3. Invite alumni to explore. It's that easy!</span>
          </motion.p>
          <div className='recruiting-button-container'>
            <LearnMoreButton />
          </div>
        </div>

        <div className={s.section}>
          <OneWeekImplementation />
        </div>
      </AnimatedContainer>
    </div>
  </section>
)

export default OneWeekImplementationSection
